import { render, staticRenderFns } from "./FeaturedOffersContainer.vue?vue&type=template&id=b2f317ec&lang=pug&"
import script from "./FeaturedOffersContainer.vue?vue&type=script&lang=js&"
export * from "./FeaturedOffersContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2f317ec')) {
      api.createRecord('b2f317ec', component.options)
    } else {
      api.reload('b2f317ec', component.options)
    }
    module.hot.accept("./FeaturedOffersContainer.vue?vue&type=template&id=b2f317ec&lang=pug&", function () {
      api.rerender('b2f317ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/featured-offers/FeaturedOffersContainer.vue"
export default component.exports